import {Injectable} from '@angular/core';
import {MatDialog, MatSnackBar} from '@angular/material';
import {SnackbarMessageComponent} from '../components/snackbar-message/snackbar-message.component';
import {NotificationDialogComponent} from '../components/notification-dialog/notification-dialog.component';

@Injectable()
export class NotificationsService {

    isLoading: boolean;

    constructor(public snackBar: MatSnackBar,
                private matDialog: MatDialog) {

    }

    startLoading() {
        setTimeout(() => {
            this.isLoading = true;
            this.snackBar.openFromComponent(SnackbarMessageComponent, {
                data: {
                    loading: true,
                    message: 'NOTIFICATIONS.LOADING'
                }
            });
        }, 0.0);
    }

    dismissLoading(message = null, statusCode = null) {
        setTimeout(() => {
            this.isLoading = false;
            this.snackBar.dismiss();
            switch (true) {
                case +statusCode >= 200 && +statusCode < 300:
                    this.error(message);
                    break;
                case +statusCode >= 400 && +statusCode < 600 : // +statusCode == 0 must be applied if No connection
                    this.error(message);
                    break;
                default:
                    break;
            }
        }, 0.0);

    }

    silentError(error: string | any) {
        console.error('[AETS-Error]', error);
    }

    error(message) {
        if (!message) {
            message = 'NOTIFICATIONS.ERROR';
        }
        if (message.length > 100) {
            this.openDialog(message, 'NOTIFICATIONS.ERROR', 'error');
            return;
        }

        this.openSnackbarComponent(message, 'error', 'close');
        this.isLoading = false;
    }

    warn(message, action?: { label: string, cb: (args) => void }) {
        if (message.length > 100) {
            this.openDialog(message, 'NOTIFICATIONS.ALERT', 'warn', action);
            return;
        }

        this.openSnackbarComponent(message, 'warn', 'warning', action);
        this.isLoading = false;
    }

    info(message, action?: { label: string, cb: (args) => void }) {
        if (message.length > 100) {
            this.openDialog(message, 'NOTIFICATIONS.INFO', 'info', action);
            return;
        }

        this.openSnackbarComponent(message, 'info', 'info', action);
        this.isLoading = false;
    }

    success(message) {
        if (!message) {
            message = 'NOTIFICATIONS.SUCCESS';
        }
        if (message.length > 100) {
            this.openDialog(message, 'NOTIFICATIONS.SUCCESS', 'success');
            return;
        }

        this.openSnackbarComponent(message, 'success', 'done');
        this.isLoading = false;
    }

    openSnackbarComponent(message, status, icon, action?: { label: string, cb: (args) => void }) {
        this.snackBar.openFromComponent(SnackbarMessageComponent, {
            data: {
                message,
                status,
                icon,
                action
            },
            duration: !!action ? 60000 : 3000
        });
    }

    openDialog(message, title, type, action?: { label: string, cb: (args) => void }) {
        this.matDialog.open(NotificationDialogComponent, {
            width: '500px',
            data: {
                title,
                message,
                type,
                action
            }
        });
    }

}
